/**
 * Card primitives for Hand and Foot: Saloon.
 *
 * Threes have no point value in the rules (§3) and only ever appear as
 * penalties at scoring time (§6), so they are treated as unmeldable.
 */
export const SUITS = ["clubs", "diamonds", "hearts", "spades"];
export const RANKS = [
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "jack",
    "queen",
    "king",
    "ace",
    "joker"
];
/** Ranks that may anchor a meld: everything except wild cards and threes. */
export const MELDABLE_RANKS = [
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "jack",
    "queen",
    "king",
    "ace"
];
const CARD_VALUES = {
    2: 20,
    3: 0,
    4: 5,
    5: 5,
    6: 5,
    7: 5,
    8: 10,
    9: 10,
    10: 10,
    jack: 10,
    queen: 10,
    king: 10,
    ace: 20,
    joker: 50
};
const MELDABLE_RANK_SET = new Set(MELDABLE_RANKS);
/** Face value used both for cards on the table and for cards caught in a hand (§3). */
export function getCardValue(card) {
    return CARD_VALUES[card.rank];
}
export function isWild(card) {
    return card.rank === "2" || card.rank === "joker";
}
export function isThree(card) {
    return card.rank === "3";
}
export function isRed(card) {
    return card.color === "red";
}
/** Accepts any string so untrusted payloads can be narrowed at the boundary. */
export function isMeldableRank(rank) {
    return MELDABLE_RANK_SET.has(rank);
}
/** A card that can anchor a meld: a natural, non-three rank. */
export function isNatural(card) {
    return isMeldableRank(card.rank);
}
/** Freezes the discard pile when discarded: a wild two or either three (§5). */
export function freezesDiscardPile(card) {
    return card.rank === "2" || card.rank === "3";
}
//# sourceMappingURL=card.js.map